import React, { useMemo } from 'react';
import { Flex, Selector } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelFactory } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import UnitEditor from "./UnitEditor.js";
import { prefixVariant } from '../../../Util.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('ui-attributes.condition.comparator.type.unit.UnitBetweenComparatorEditor');
export default function UnitBetweenComparatorEditor(props) {
  const {
    attribute,
    value,
    usage,
    variant,
    suggestor
  } = props;
  const Model = ModelFactory.get(value);
  const onModelChange = useValueChange(Model, props);
  const value1 = Model.getValue1(value);
  const value2 = Model.getValue2(value);
  const includesValue1 = Model.getIncludesValue1(value);
  const includesValue2 = Model.getIncludesValue2(value);
  const gtLabel = t('numberGT');
  const gteLabel = t('numberGTE');
  const ltLabel = t('numberLT');
  const lteLabel = t('numberLTE');
  const isTable = usage === 'table';
  const style = isTable ? {
    width: '100%'
  } : null;
  const gtOptions = useMemo(() => {
    return [{
      name: gtLabel,
      value: false
    }, {
      name: gteLabel,
      value: true
    }];
  }, [gtLabel, gteLabel]);
  const ltOptions = useMemo(() => {
    return [{
      name: ltLabel,
      value: false
    }, {
      name: lteLabel,
      value: true
    }];
  }, [ltLabel, lteLabel]);
  return /*#__PURE__*/_jsxs(Flex, {
    style: style,
    variant: isTable ? 'colS' : 'rowM',
    align: isTable ? 'stretch' : 'center',
    children: [/*#__PURE__*/_jsx(Selector, {
      variant: variant,
      toggleVariant: prefixVariant('conditionSelector', usage, 'inline'),
      value: includesValue1,
      onChange: onModelChange,
      eventData: "setIncludesValue1",
      values: gtOptions
    }), /*#__PURE__*/_jsx(UnitEditor, {
      usage: usage,
      variant: variant,
      suggestor: suggestor,
      attribute: attribute,
      value: value1,
      onChange: onModelChange,
      eventData: "setValue1"
    }), /*#__PURE__*/_jsx(Selector, {
      variant: variant,
      toggleVariant: prefixVariant('conditionSelector', usage, 'inline'),
      value: includesValue2,
      onChange: onModelChange,
      eventData: "setIncludesValue2",
      values: ltOptions
    }), /*#__PURE__*/_jsx(UnitEditor, {
      usage: usage,
      variant: variant,
      suggestor: suggestor,
      attribute: attribute,
      value: value2,
      onChange: onModelChange,
      eventData: "setValue2"
    })]
  });
}
function createFor(unitType) {
  const editor = props => {
    return UnitBetweenComparatorEditor({
      ...props,
      unitType
    });
  };
  editor.isInline = true;
  return editor;
}
UnitBetweenComparatorEditor.createFor = createFor;